import { BehaviorSubject } from 'rxjs';

/**
 * It takes an object and a property name, and returns an observable that emits the value of that
 * property whenever it changes
 * @param {T} target - T - the object you want to observe
 * @param {K} key - K - The key of the property to observe.
 * @returns A BehaviorSubject.
 */
export function observeProperty<T, K extends keyof T>(target: T, key: K) {
  const subject = new BehaviorSubject<T[K]>(target[key]);
  Object.defineProperty(target, key, {
    get(): T[K] {
      return subject.getValue();
    },
    set(newValue: T[K]): void {
      if (newValue !== subject.getValue()) {
        subject.next(newValue);
      }
    },
  });
  return subject;
}